import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InviteColeagueModalComponent} from "./modal/invite-colleague/invite-colleague-modal.component";
import {LogbookSharedModule} from "@logbook/shared";

@NgModule({
    imports: [
        CommonModule,
        LogbookSharedModule
    ],
    declarations: [
        InviteColeagueModalComponent
    ],
    entryComponents: [
        InviteColeagueModalComponent
    ]
})
export class LogbookSettingsSharedModule {
}
